<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" max-width="40%" scrollable>
      <v-card v-if="alertToEdit !== null">
        <v-card-title
          class="justify-center text-h5 font-weight-light"
          style="color: #1976d2"
        >
          Modifier une alerte
        </v-card-title>
        <v-card-text>
          <v-form>
            <v-row dense>
              <v-col cols="12">
                <v-card
                  color="white"
                  dark
                  elevation="0"
                  class="rounded-xl"
                  style="padding: 2em"
                >
                  <v-row dense>
                    <v-col cols="12">
                      <v-alert
                        outlined
                        type="error"
                        text
                        prominent
                        border="left"
                        style="margin-top: 1em"
                        v-if="formErrors.length > 0"
                      >
                        <ul>
                          <li v-for="(error, index) in formErrors" :key="index">
                            • {{ error }}
                          </li>
                        </ul>
                      </v-alert>
                      Complétez les informations
                    </v-col>
                    <v-col cols="12">
                      <v-row>
                        <v-col cols="10" offset="1">
                          <v-combobox
                            light
                            v-model="jobBoardJobModel"
                            :items="items"
                            :loading="isLoading"
                            :search-input.sync="search"
                            prepend-inner-icon="mdi-electron-framework"
                            chips
                            small-chips
                            clearable
                            hide-details
                            hide-selected
                            item-text="name"
                            item-value="symbol"
                            label="Métier, mots clés ou entreprise"
                            solo
                            multiple
                          >
                            <template v-slot:no-data>
                              <v-list-item>
                                <v-list-item-title>
                                  Entrer un métier, mots clés ou entreprise pour
                                  rechercher
                                  <strong>des offres</strong>
                                </v-list-item-title>
                              </v-list-item>
                            </template>
                            <template v-slot:item="{ item }">
                              <v-list-item-content>
                                <v-list-item-title
                                  v-text="item.name"
                                ></v-list-item-title>
                              </v-list-item-content>
                            </template>
                          </v-combobox>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12">
                      <v-row>
                        <v-col cols="10" offset="1" style="padding-top: 3em">
                          <v-combobox
                            light
                            v-model="where"
                            :items="locationItems"
                            :loading="locationIsLoading"
                            :search-input.sync="locationSearch"
                            prepend-inner-icon="mdi-map-marker-radius-outline"
                            chips
                            clearable
                            hide-details
                            hide-selected
                            item-text="name"
                            item-value="symbol"
                            label="Où"
                            v-on:keyup="locationFieldKeyUpListerner"
                            solo
                          >
                            <template v-slot:no-data>
                              <v-list-item>
                                <v-list-item-title>
                                  Entrer une ville, une commune, une préfecture,
                                  etc...
                                </v-list-item-title>
                              </v-list-item>
                            </template>
                            <template v-slot:item="{ item }">
                              <v-list-item-content>
                                <v-list-item-title
                                  v-text="item.name"
                                ></v-list-item-title>
                              </v-list-item-content>
                            </template>
                          </v-combobox>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12">
                      <v-row>
                        <v-col cols="4" offset="4" style="padding-top: 2em">
                          <v-btn
                            elevation="24"
                            large
                            rounded
                            color="primary"
                            style="width: 100%"
                            v-on:click="submitUpdatedAlert"
                          >
                            <v-icon left> mdi-content-save-check</v-icon>
                            Mettre à jour
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn
            rounded
            color="blue-grey"
            class="ma-2 white--text"
            text
            @click="hideModal"
          >
            <v-icon left> mdi-close-box-multiple</v-icon>

            Fermer
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import HttpClient from "@/services/HttpClient/HttpClient";
import { timeSince } from "@/helper/DateTimeHelper";

export default {
  name: "EditAlert",
  props: {
    alertToEdit: Object,
    displayDialog: Boolean,
    hideModalComponentCallback: Function,
  },
  data() {
    return {
      isLoading: false,
      items: [],
      locationItems: [],
      jobBoardJobModel: [],
      where: null,
      search: null,
      locationSearch: null,
      locationIsLoading: false,
      formErrors: [],
      dialog: false,
      snackbarSaveOfferSuccess: false,
      snackbarSaveOfferFailed: false,
      currentUser: null,
      deleteOfferAlertDisplay: false,
      disableOfferAlert: false,
      deleteSnackbarFailed: false,
    };
  },
  mounted() {
    console.log(this.alertToEdit);
    this.dialog = this.displayDialog;
    const currentUser = JSON.parse(localStorage.getItem("currentUser"));
    this.currentUser = currentUser;
    this.alertToEdit.work.split(", ").forEach((elt) => {
      this.jobBoardJobModel.push({
        name: elt,
      });
    });
    this.where = this.alertToEdit.location;
  },
  methods: {
    hideModal() {
      this.dialog = false;
    },
    editOffer() {
      const httpClient = new HttpClient();
      const user = JSON.parse(localStorage.getItem("currentUser"));
      httpClient
        .saveJobOffer(
          {
            alertToEdit: this.alertToEdit.id,
            seeker: user.seeker.id,
          },
          localStorage.getItem("jwt-token")
        )
        .then((res) => {
          this.snackbarSaveOfferSuccess = true;
          setTimeout(() => {
            this.snackbarSaveOfferSuccess = false;
          }, 3000);
        })
        .catch((err) => {
          if (err.response.status === 401) {
            this.$router.push("/logout");
          } else if (err.response.status === 503) {
            this.snackbarSaveOfferFailed = true;
            setTimeout(() => {
              this.snackbarSaveOfferFailed = false;
            }, 3000);
          } else {
            alert("Une erreur s'est produite");
            console.log(err);
          }
        });
    },
    switchItemState() {
      this.disableOfferAlert = true;
    },
    switchItemStateForReal() {
      this.disableOfferAlert = false;
      const item = this.alertToEdit;
      const httpClient = new HttpClient();
      let snackBarParameter = item.isActive ? "disabled" : "enabled";
      console.log(snackBarParameter);
      httpClient
        .putFromApiPlatformUri(
          "/api/job_offers/" + item.id,
          {
            isActive: !item.isActive,
          },
          localStorage.getItem("jwt-token")
        )
        .then(() => {
          this.dialog = false;
          window.location = "/company/offers?" + snackBarParameter;
        })
        .catch((error) => {
          console.log(error);
          if (error.response.status === 401) {
            this.$router.push("/logout");
          } else {
            alert("Une erreur s'est produite");
          }
        });
    },
    checkForm: function () {
      this.formErrors = [];
      let isValid = true;

      if (this.jobBoardJobModel === null) {
        isValid = false;
        this.formErrors = [];
        this.formErrors.push("Complétez les informations.");
      } else if (this.jobBoardJobModel.length === 0) {
        isValid = false;
        this.formErrors = [];
        this.formErrors.push("Complétez les informations.");
      }

      if (this.where === null) {
        isValid = false;
        this.formErrors = [];
        this.formErrors.push("Complétez les informations.");
      } else if (
        typeof this.where !== "object" &&
        typeof this.where !== "string"
      ) {
        isValid = false;
        this.formErrors = [];
        this.formErrors.push("Complétez les informations.");
      } else if (typeof this.where == "string" && this.where.trim() === "") {
        isValid = false;
        this.formErrors = [];
        this.formErrors.push("Complétez les informations.");
      }

      return isValid;
    },
    updateAlert: function () {
      if (this.checkForm()) {
        let searchContent = [];
        let jobLocation = "";
        this.jobBoardJobModel.forEach((elt) => {
          if (typeof elt === "object") {
            searchContent.push(elt.name);
          } else {
            searchContent.push(elt);
          }
        });
        if (typeof this.where === "object") {
          jobLocation = this.where.name;
        } else {
          jobLocation = this.where;
        }

        return true;
      }

      return false;
    },
    submitUpdatedAlert: function () {
      if (this.checkForm()) {
        const httpClient = new HttpClient();
        let searchContent = [];
        let jobLocation = "";
        this.jobBoardJobModel.forEach((elt) => {
          if (typeof elt === "object") {
            searchContent.push(elt.name);
          } else {
            searchContent.push(elt);
          }
        });
        if (typeof this.where === "object") {
          jobLocation = this.where.name;
        } else {
          jobLocation = this.where;
        }
        console.log(this.alertToEdit.id);
        httpClient
          .putFromApiPlatformUri(
            `/api/candidate/alerts/${this.alertToEdit.id}`,
            {
              searchContent,
              jobLocation,
            },
            localStorage.getItem("jwt-token")
          )
          .then((value) => {
            this.hideModalComponentCallback();
          })
          .catch((error) => {
            if (error.response.status === 401) {
              this.$router.push("/logout");
            } else {
              alert("Une erreur s'est produite");
            }
          });
      }
    },
    createNewAlert: function () {
      const httpClient = new HttpClient();
      let searchContent = [];
      let jobLocation = "";
      this.jobBoardJobModel.forEach((elt) => {
        if (typeof elt === "object") {
          searchContent.push(elt.name);
        } else {
          searchContent.push(elt);
        }
        if (typeof this.where === "object") {
          jobLocation = this.where.name;
        } else {
          jobLocation = this.where;
        }
      });
      httpClient
        .createNewJobOffersAlert(
          {
            searchContent: searchContent,
            jobLocation: jobLocation,
          },
          localStorage.getItem("jwt-token")
        )
        .then((value) => {
          this.snackbarAlertSuccess = true;
          setTimeout(() => {
            this.snackbarAlertSuccess = false;
          }, 3000);
        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.$router.push("/logout");
          } else if (error.response.status === 503) {
            this.snackbarAlertFailed = true;
            setTimeout(() => {
              this.snackbarAlertFailed = false;
            }, 3000);
          } else {
            alert("Une erreur s'est produite");
          }
        });
    },
    locationFieldKeyUpListerner: function (event) {
      event.preventDefault();
      if (event.keyCode === 13) {
        this.updateAlert();
      }
    },
    editAlertSucceedMessage() {
      this.alertEditMessage = "Votre alerte a bien été mise à jour.";
    },
  },
  watch: {
    dialog(val) {
      if (!val) {
        this.hideModalComponentCallback();
      }
    },
    jobBoardJobModel(val) {
      if (val != null) this.tab = 0;
      else this.tab = null;

      if (val.length > 0) {
        this.updateAlert();
      }
    },
    search(val) {
      // Items have already been loaded
      if (this.items.length > 0 && val) {
        const result = this.items.filter(
          (value) =>
            value.name.toLowerCase() === val.toLowerCase() ||
            value.name.toLowerCase().search(val.toLowerCase()) !== -1
        );
        if (result.length > 0) {
          return;
        }
      }
      this.isLoading = true;
      const httpClient = new HttpClient();
      httpClient
        .fetchCompanyKeyWordsJobTitleAndActivitySector(
          val,
          localStorage.getItem("jwt-token")
        )
        .then((res) => {
          this.items = res.data;
        })
        .catch((err) => {
          if (err.response.status === 401) {
            this.$router.push("/logout");
          } else {
            alert("Une erreur s'est produite");
          }
        })
        .finally(() => (this.isLoading = false));
    },
    where(val) {
      if (val != null) this.locationTab = 0;
      else this.locationTab = null;

      if (typeof val === "object") {
        this.updateAlert();
      } else if (typeof val === "string" && val.trim() !== "") {
        this.updateAlert();
      }
    },
    locationSearch(val) {
      // Items have already been loaded
      if (this.locationItems.length > 0 && val) {
        const result = this.locationItems.filter(
          (value) =>
            value.name.toLowerCase() === val.toLowerCase() ||
            value.name.toLowerCase().search(val.toLowerCase()) !== -1
        );
        if (result.length > 0) {
          return;
        }
      }
      this.locationIsLoading = true;
      const httpClient = new HttpClient();
      httpClient
        .fetchLocations(val, localStorage.getItem("jwt-token"))
        .then((res) => {
          res.data.forEach((elt) => {
            this.locationItems.push({
              name: elt.jobLocation,
            });
          });
        })
        .catch((err) => {
          if (err.response.status === 401) {
            this.$router.push("/logout");
          } else {
            alert("Une erreur s'est produite");
          }
        })
        .finally(() => (this.locationIsLoading = false));
    },
  },
};
</script>

<style scoped></style>
